// import React from 'react';

import { withStyles, Theme, createStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

export const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            color: '#7F899C',
            padding: '20px 5px 20px 10px'
        },
        body: {
            padding: '12px 5px 12px 10px',
            color: '#1D3155'
        },
    }),
)(TableCell);